import React, { useState } from 'react'
import { FormControlLabel, makeStyles, Switch, useMediaQuery } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  container: {
    placeItems: "normal",
    maxWidth: ({ isMobile }) => isMobile && 200,
    width: ({ isMobile, width }) => (isMobile ? 200 : width),
  },
  label: {
    minWidth: 120,
    marginRight: 10,
    color: ({ touched, hover }) =>
      (touched || hover) ? theme.palette.primary.main : "black",
  },
}));

const SimpleSwitch = ({ label="", labelPos="top", name, value, onChange=()=>{}, disabled, color="primary", containerClass="", className="" }) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [touched, setTouched] = useState(false);
  const [hover, setHover] = useState(false);
  const classes = useStyles({ isMobile, touched, hover });
  
  return (
    <FormControlLabel
      className={classes.container + ` ${containerClass}`}
      disabled={disabled}
      label={<p className={classes.label}>{label}</p>}
      labelPlacement={isMobile ? "top" : labelPos}
      control={
        <Switch
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
          onBlur={() => setTouched(false)}
          onFocus={e => setTouched(true)}
          defaultChecked={false}
          disabled={disabled}
          onChange={({ target }) => onChange({target: { name, value: target.checked }})}
          color={color}
          checked={value}
          name={name}
        />
      }
    />
  )
}

export default SimpleSwitch